<template>
  <el-dialog
    :title="detail.header"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
  >
    <div class="content">
      <div class="info" v-html="detail.richTextContent"></div>
      <!-- <div class="user">发布人：{{ detail.withNewPeople }}</div> -->
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "NoticeMessage",
  components: {},
  props: {},
  data() {
    return {
      dialogVisible: false,
      list: [],
      detail: {}
    };
  },
  created() {
    this.getList();
    this.getUnreadMessages();
  },
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.list.shift();
      this.checkDialog();
    },
    async getList() {
      let req = {
        userId: this.$store.getters.getUserInfo.userId,
        pageNum: 1,
        pageSize: 1000
      };
      let res = await this.$Http.getPcSystemMessage(req);
      if (res.code == 200) {
        let listTemp = res.data.list || [];
        this.total = res.data.total || 0;
        let list = [];
        for (var i = 0; i < listTemp.length; i++) {
          if (listTemp[i].status == 2 && listTemp[i].popup == 1) {
            list.push(listTemp[i]);
          }
        }
        // console.log(list)
        this.list = list;
        this.checkDialog();
      } else if (res.code == 101) {
        this.list = [];
        this.total = 0;
      } else {
        this.$message({
          showClose: true,
          type: "error",
          message: res.messsage
        });
      }
    },
    checkDialog() {
      let arr = this.list;
      //   console.log(arr);
      for (var i = 0; i < arr.length; i++) {
        this.detail = arr[i];
        this.dialogVisible = true;
        this.modify(this.detail.id);
        return;
      }
    },
    async modify(id) {
      let req = {
        generalMessageHelpId: id,
        userId: this.$store.getters.getUserInfo.userId
      };
      let res = await this.$Http.modifySystemMessageStatus(req);
      if (res.code == 200) {
        this.getUnreadMessages();
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    async getUnreadMessages() {
      let res = await this.$Http.getUnreadMessages({
        userId: this.$store.getters.getUserInfo.userId
      });
      if (res.code == 200) {
        this.$store.commit("unreadMessages", res.data.number || 0);
      } else {
        this.$store.commit("unreadMessages", 0);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 20px;
  height: 300px;
  // display: flex;
  // align-items: ;
  .title {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }
  .user {
    font-size: 14px;
    text-align: right;
  }
  .info {
    font-size: 14px;
    text-indent: 30px;
    height: 100%;
    overflow-y: scroll;
  }
}
</style>
